import {
  CheckCircleIcon,
  FunnelIcon,
  PlusCircleIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetCompletedLessonsQuery,
  useGetCoursesQuery,
} from "../../../../store/courses";
import { useGetProfessionsQuery } from "../../../../store/professions";
import {
  setCompletedLessons,
  setCourses,
} from "../../../../store/reducers/coursesSlice";
import Loader from "../../../commons/Loader";
import ProfessionCourseFilters from "../../../dropdown/ProfessionCourseFilters";
import IconButton from "../../../iconButton";
import AdminCourseArchiveSlideOver from "../slideovers/AdminCourseArchiveSlideOver";
import AdminCourseSlideOver from "../slideovers/AdminCourseSlideOver";
import place_holder_pdf from "../../../../images/place-holder-pdf.png";
import GlobalAlertSkeleton from "../../../commons/Skeleton/GlobalAlertSkeleton";
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const options = [
  {
    id: 1,
    value: "Course category",
  },
  {
    id: 2,
    value: "Course category 2",
  },
  {
    id: 3,
    value: "Course category 3",
  },
];

const DashboardAdminEducationCenter = () => {
  const initialRender = useRef(false);
  const location = useLocation();
  const [courseSlideOver, setCourseSlideOver] = useState(false);
  const [editCourseSlideOver, setEditCourseSlideOver] = useState(false);
  const [archiveCourseSlideOver, setArchiveCourseSlideOver] = useState(false);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState();
  const [categoryFilter, setCategoryFilter] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: professions } = useGetProfessionsQuery();
  const [guides, setGuides] = useState([]);

  const {
    data: courses,
    isSuccess: coursesIsSuccess,
    isLoading: coursesIsLoading,
  } = useGetCoursesQuery();

  const {
    data: allCompletedLessons,
    isSuccess: allLessonsSuccess,
    isLoading: allLessonsIsLoading,
  } = useGetCompletedLessonsQuery();

  useEffect(() => {
    if (
      courses &&
      !coursesIsLoading &&
      courses.data &&
      !initialRender.current
    ) {
      const filteredCoursesData = courses.data.filter((course) => course);
      const courseCategoryResponse = filteredCoursesData.map((item) => ({
        id: item.courseCategory.id,
        value: item.courseCategory.name,
      }));

      const uniqueCourseCategoryResponse = [
        ...new Set(courseCategoryResponse.map(JSON.stringify)),
      ].map(JSON.parse);

      setSelectedFilter(
        location?.state?.selectedFilter || { id: "all", value: "All" }
      );
      setCategoryFilter([
        { id: "all", value: "All" },
        ...uniqueCourseCategoryResponse,
      ]);
      initialRender.current = true;

      if (!location?.state?.selectedFilter) {
        dispatch(setCourses(courses.data));
      }
    }
  }, [coursesIsSuccess]);

  const handleFilterCourses = (courses, id) => {
    let filteredCoursesData = [];
    if (id == "all") {
      filteredCoursesData = courses?.filter(
        (course) => course && course.courseCategory.name !== "Guides"
      );
      setFilteredCourses(filteredCoursesData);
    } else {
      filteredCoursesData = courses.filter(
        (course) =>
          course.courseCategory.id == id &&
          course.courseCategory.name != "Guides"
      );
      setFilteredCourses(filteredCoursesData);
    }
    const filteredCourse = courses?.filter(
      (course) => course && course.courseCategory.name == "Guides"
    );
    setGuides(filteredCourse ?? []);
  };

  useEffect(() => {
    if (selectedFilter && courses) {
      handleFilterCourses(courses?.data, selectedFilter.id);
    }
  }, [selectedFilter, courses]);

  useEffect(() => {
    if (allCompletedLessons && !allLessonsIsLoading) {
      dispatch(setCompletedLessons(allCompletedLessons.data));
    }
  }, [allLessonsSuccess]);

  const goToCourseDetail = (course) => {
    navigate("/admin-dashboard/education-center/course", {
      state: {
        course: course,
        lessonCount: getLessonCount(course),
        selectedFilter: selectedFilter,
      },
    });
  };

  const goToGuidDetail = (guide) => {
    navigate(`/admin-dashboard/education-center/guide`, {
      state: {
        guide: guide,
      },
    });
  };

  const getLessonCount = (course) => {
    if (course && course.lessons) {
      return course.lessons.length;
    } else {
      return 0;
    }
  };

  const getStatusClasses = (status) => {
    switch (status) {
      case "Start":
        return "bg-[#D2ECFF] text-xs font-bold leading-[160%] text-primary px-[10px] py-1 rounded-md h-[27px] flex items-center justify-center";
      case "In Progress":
        return "bg-[#FFEBF8] text-xs font-bold leading-[160%] text-[#D834A0] px-[10px] py-1 rounded-md h-[27px] flex items-center justify-center";
      case "Completed":
        return "bg-[#16CA7C] text-xs font-bold leading-[160%] text-white px-[10px] py-1 rounded-md h-[27px] flex items-center justify-center";
      default:
        return "bg-customGray text-white";
    }
  };

  const getButtonClasses = (status) => {
    switch (status) {
      case "Start Course":
        return "bg-white border border-[#1E90FE] text-sm font-black leading-[160%] text-[#1E90FE] p-[10px] rounded-md h-[40px] flex items-center justify-center w-full uppercase";
      case "Continue Course":
        return "bg-white border border-[#D834A0] text-sm font-black leading-[160%] text-[#D834A0] p-[10px] rounded-md h-[40px] flex items-center justify-center w-full uppercase";
      case "Review Course":
        return "bg-white border border-[#16CA7C] text-sm font-black leading-[160%] text-[#16CA7C] p-[10px] rounded-md h-[40px] flex items-center justify-center w-full uppercase";
      default:
        return "bg-customGray text-white";
    }
  };

  const StatusLabel = ({ status }) => {
    const classes = getStatusClasses(status);

    return <span className={classes}>{status}</span>;
  };

  const courseLabel = {
    "Start Course": "Start",
    "Review Course": "Completed",
    "Continue Course": "In Progress",
  };

  const handleCourseSlideOverClose = () => {
    setCourseSlideOver(false);
    setEditCourseSlideOver(false);
    setArchiveCourseSlideOver(false);
  };

  return (
    <div className="col-span-12 -mt-3">
      <div className="flex md:items-center justify-between gap-5 flex-col md:flex-row mb-5">
        <div className="flex md:block justify-between items-center">
          <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
            Education Center
          </h4>
          <button
            className="w-12 h-12 flex md:hidden justify-center items-center rounded-[10px] bg-primary cursor-pointer"
            onClick={() => setCourseSlideOver(true)}
          >
            <PlusCircleIcon className="w-6 h-6 text-white" />
          </button>
        </div>
        <div className="flex items-center md:justify-end gap-[30px] w-full md:w-[50%]">
          <ProfessionCourseFilters
            options={categoryFilter}
            selectedOption={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            icon={FunnelIcon}
            classes="px-[14px] py-3 border w-full md:w-[274px] border-solid border-[#EBEFF3] rounded-[10px] h-[48px] bg-[#FFFFFF] flex items-center justify-between"
            textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm font-medium text-[#485868]"
            leftIconClasses="icon w-6 h-6 text-customGray"
            rightIconClasses="-mr-1 h-6 w-6 text-[#485868] font-bold"
            menuClasses="absolute left-0 z-10 mt-4 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          />
          <button
            className="w-12 h-12 hidden md:flex justify-center items-center rounded-[10px] bg-primary cursor-pointer"
            onClick={() => setCourseSlideOver(true)}
          >
            <PlusCircleIcon className="w-6 h-6 text-white" />
          </button>
        </div>
      </div>
      {filteredCourses.length > 0 ? (
        <div className="grid grid-cols-12 gap-6 mb-[30px]">
          {filteredCourses?.map((course) => (
            <div className="col-span-12 md:col-span-6 xxl:col-span-4 p-5 rounded-md bg-[#FFFFFF] border border-solid border-[#EBEFF3]">
              <h6 className="font-medium text-base leading-[160%] text-customGray pb-[14px] border-b border-b-solid border-[#EBEFF3]">
                {course.name}
              </h6>
              <p className="text-sm leading-[140%] text-[#485868] py-[14px] border-b border-b-solid border-[#EBEFF3] min-h-[69px]">
                {course.description}
              </p>
              <ul className="flex items-center text-sm leading=[160%] font-bold text-customGray pt-[14px] pb-7">
                <li>
                  {getLessonCount(course)}{" "}
                  {getLessonCount(course) === 1 ? "Lesson" : "Lessons"}
                </li>
                <li className="text-[#BEC2C5] mx-[14px]">&#8226;</li>
                <li>45 min</li>
                <li className="text-[#BEC2C5] mx-[14px]">&#8226;</li>
                <li>
                  <StatusLabel status={courseLabel[course?.progress_status]} />
                </li>
              </ul>
              <IconButton
                title={`${course?.progress_status}`}
                icon={
                  course?.progress_status === "Review Course" && CheckCircleIcon
                }
                classes={getButtonClasses(course?.progress_status)}
                // classes="text-sm font-black leading-[160%] uppercase text-primary flex items-center justify-center rounded-[10px] h-10 w-full mb-2 uppercase border border-solid border-primary hover:bg-[#EBF7FF]"
                iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                // onClick={() => goToCourseDetail(course)}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-12 gap-6 mb-[30px]">
          {[...Array(3)].map(() => (
            <div className="col-span-12 md:col-span-6 xxl:col-span-4 p-5 rounded-md bg-[#FFFFFF] border border-solid border-[#EBEFF3]">
              <GlobalAlertSkeleton />
            </div>
          ))}
        </div>
      )}
      {!coursesIsLoading&&filteredCourses.length < 1 && (
        <div className="flex items-center justify-center mt-5 text-lg text-primary bg-white py-6 font-bold">
          No courses are currently available.
        </div>
      )}
      {guides && guides.length > 0 && (
        <div className="flex md:items-center justify-between gap-5 flex-col md:flex-row mb-5">
          <div className="flex md:block justify-between items-center">
            <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
              Guides
            </h4>
          </div>
        </div>
      )}
      <div className="mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-[30px]">
          {guides.map((pdf) => (
            <div className="col-span-12 md:col-span-6 xxl:col-span-4 p-5 rounded-md bg-[#FFFFFF] border border-solid border-[#EBEFF3]">
              <h6 className="font-medium text-base leading-[160%] text-customGray pb-[14px] border-b border-b-solid border-[#EBEFF3]">
                {pdf.name}
              </h6>
              <img
                src={pdf?.image ? pdf?.image : place_holder_pdf}
                alt={pdf.name}
                className="w-full h-full object-cover rounded-md mb-4"
              />
              {pdf.description && (
                <p className="text-sm leading-[140%] text-[#485868] py-[14px] border-b border-b-solid border-[#EBEFF3] min-h-[69px]">
                  {pdf.description}
                </p>
              )}
              <IconButton
                title={`View Guide`}
                icon={null}
                classes={getButtonClasses("Start Course")}
                iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                onClick={() => goToGuidDetail(pdf)}
              />
            </div>
          ))}
        </div>
      </div>
      <AdminCourseSlideOver
        show={courseSlideOver}
        setCourseSlideOver={setCourseSlideOver}
        handleClose={handleCourseSlideOverClose}
        type="Create"
      />
      <AdminCourseSlideOver
        show={editCourseSlideOver}
        setCourseSlideOver={setEditCourseSlideOver}
        handleClose={handleCourseSlideOverClose}
        type="Edit"
      />
      <AdminCourseArchiveSlideOver
        show={archiveCourseSlideOver}
        setCourseSlideOver={setArchiveCourseSlideOver}
        handleClose={handleCourseSlideOverClose}
      />
    </div>
  );
};

export default DashboardAdminEducationCenter;
